import * as React from 'react';
import { fieldValidation, SuggesterCustomFormField } from '../../../../amorg-common';
import { getCustomFormSelectionOverview } from '../../../../api/customFormClientApi';
import { AnswerFieldContext } from '../customFormFieldFactory';
import { SuggesterTextInputWithSave } from '../../../../designSystem/inputs/SuggesterTextInputWithSave';
import { FormField } from '../../../../designSystem/formField/FormField';
import { CustomFormFieldHeader } from '../../[parm]/_components/CustomFormFieldHeader';

type SuggesterCustomFormFieldComponentProps = AnswerFieldContext & {
    field:SuggesterCustomFormField
}
export function SuggesterCustomFormFieldComponent(props:SuggesterCustomFormFieldComponentProps):JSX.Element
{
    const [options, setOptions] = React.useState<string[]>([]);
    const [loading, setLoading] = React.useState(true);
    const [inErrorState, setInErrorState] = React.useState(
        !fieldValidation.customFormAnswer.selection.value(getSelectionValue())
    );

    React.useEffect(()=>{
        const getOptions = async () => {
            await updateOptions();
            setLoading(false);
        };
        getOptions();
    }, []);

    async function updateOptions()
    {
        const options = await getCustomFormSelectionOverview(props.siteId, props.answer.formId);
        const fieldSelections = options.activeSelections.find(f => f.fieldId === props.field.fieldId);
        setOptions(fieldSelections?.selections.map(v => v.value) || []);
    }

    function getSelectionValue():string
    {
        const selection = props.answer.selections.find(s => s.fieldId === props.field.fieldId);
        return selection.value;
    }

    async function handleSave(value:string)
    {
        if(fieldValidation.customFormAnswer.selection.value(value))
        {
            setLoading(true);
            setInErrorState(false);
            await props.onSubmit([{ fieldId: props.field.fieldId, value }]);

            const options = await getCustomFormSelectionOverview(props.siteId, props.answer.formId);
            const fieldSelections = options.activeSelections.find(f => f.fieldId === props.field.fieldId);
            setOptions(fieldSelections?.selections.map(v => v.value) || []);

            setLoading(false);
            props.doUpdate();
        }
        else
        {
            setInErrorState(true);
        }
    }

    const selection = getSelectionValue();

    return (
        <section>
            <CustomFormFieldHeader field={props.field} variant={'label'} />
            <FormField
                label={''}
                inErrorState={inErrorState}
                message={inErrorState ? 'Ugyldig indtastning - maks. 1000 tegn' : undefined}
                inputComponent={
                    <SuggesterTextInputWithSave
                        disabled={loading || props.disabled}
                        value={selection}
                        visibleOptions={options.map(o => ({ text: o }))}
                        onSave={handleSave} 
                        onSelectOption={(/*selection: { identifier?: string; text: string; }*/) => 
                        {
                            // ... do nothing 
                        }}
                    />
                }
            />
        </section>
    );
}
